module.exports = __webpack_public_path__ + "media/images/banner/banner-zaim-e1cdc1ddd68b354c4e6e228439064e13.png";